var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4.11924e-07 1.67637C0.275444 1.38365 0.548421 1.0876 0.826332 0.797379C1.08369 0.529678 1.34762 0.267814 1.60251 0.0084533C1.62718 0.0084533 1.64115 0.0084533 1.65513 0.0084533C1.66911 0.0084533 1.68473 0.00845139 1.69213 0.0167903C4.21224 2.5712 6.7307 5.12562 9.28041 7.71172L16.8843 0.000114657C16.9526 0.0676653 17.0364 0.152726 17.1219 0.236956L18.5 1.59297L18.5 1.75976C18.3988 1.84816 18.2919 1.92656 18.1982 2.0258C15.2146 5.04973 12.2319 8.0745 9.24998 11.1001C6.26752 8.07561 3.28477 5.05084 0.301755 2.0258C0.208021 1.93073 0.101133 1.84816 -4.08279e-07 1.75977L-4.11924e-07 1.67637Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.a6d83170988a5014480a12bdbdcb6606.svg";
export { ForwardRef as ReactComponent };